import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getHeatsByShift = async (
  shift: number | null,
  includeDeleted = false,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ShiftId", value: shift },
    { name: "IncludeDeleted", value: includeDeleted },
  ];
  return await apiService.callV2("[RBD].[GetHeatsByShift]", parameters);
};

export const getLastestHeats = async (heatsN?: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  if (heatsN) {
    parameters.push({ name: "Heats", value: heatsN });
  }

  return await apiService.callV2("[RBD].[GetLastestNHeats]", parameters);
};

export const getGrades = async () => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  return await apiService.callV2("[STEEL].[GetGrades]", parameters);
};

export const getLadles = async () => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  return await apiService.callV2("[STEEL].[GetLadles]", parameters);
};

export const getPourbackByHeatId = async (heatId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  parameters.push({ name: "HeatId", value: heatId });
  return await apiService.callV2("[MS].[GetPourbackHeats]", parameters);
};

export const upsertHeat = async (
  HeatId: number | null,
  { HeatName, ShiftId, GradeId, SteelWeight, LadleId, IsExternal }: any,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  parameters.push(
    { name: "HeatId", value: HeatId },
    { name: "HeatName", value: HeatName },
    { name: "ShiftId", value: ShiftId },
    { name: "GradeId", value: GradeId },
    { name: "SteelWeight", value: Number(SteelWeight) },
    { name: "LadleId", value: LadleId },
    { name: "IsExternal", value: IsExternal },
  );
  return await apiService.callV2("[MS].[UpsertHeat]", parameters);
};

interface PourbackData {
  PourbackId: number | null;
  HeatId: number;
  SourceProcessId?: number | null;
  PourbackWeight: number | null;
  PourbackReasonId: number | null;
  Comments?: string | null;
  SourceTime: Date;
  IsFinished?: boolean;
}

export const upsertPourback = async (data: PourbackData) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "PourbackId", value: data.PourbackId },
    { name: "HeatId", value: data.HeatId },
    { name: "SourceProcessId", value: data.SourceProcessId ?? null },
    { name: "PourbackWeight", value: data.PourbackWeight },
    { name: "PourbackReasonId", value: data.PourbackReasonId },
    { name: "Comments", value: data.Comments ?? null },
    { name: "SourceTime", value: data.SourceTime },
    { name: "IsFinished", value: data.IsFinished ?? false },
  ];
  return await apiService.callV2("[RBD].[ManagePourback]", parameters);
};

export const deleteHeat = async (heatId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  parameters.push({ name: "HeatId", value: heatId });
  return await apiService.callV2("[MS].[DeleteHeat]", parameters);
};

export const undeleteHeat = async (heatId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "HeatId", value: heatId }];
  return await apiService.callV2("[MS].[UndeleteHeat]", parameters);
};
